<template>
    <v-row>
        <v-col cols="12" class="title-section pb-0">
            {{ $t('common.panel_monthly') }}
        </v-col>
        <v-col cols="12">
            <div class="calendar-container">
                <v-date-picker
                    :events="daysWithRoutines" readonly
                    color="#CCFF99" event-color="grey darken-1"
                    locale="es-CL" first-day-of-week="1"
                    full-width no-title
                    :picker-date.sync="pickerDate"
                />
            </div>
        </v-col>
    </v-row>
</template>

<script>
import {mapActions, mapState} from "vuex";

export default {
    name: "CalendarStudent",
    props: {
        studentId: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            pickerDate: null,
            routines: [],
        }
    },
    computed: {
        ...mapState(['routinesStudent']),
    },
    async mounted() {
        const vm = this
        let date = vm.$moment().format('YYYY-MM-DD')
        await vm.loadRoutines(date)
    },
    methods: {
        ...mapActions(['fetchRoutinesStudent']),
        daysWithRoutines(date) {
            const vm = this
            let result = []
            vm.routinesStudent.forEach(routine => {
                if (routine.rawDate.full === date) {
                    routine?.advance?.post ?
                        result.push('#5da219') :
                        result.push('#fd2e00')
                }
            })
            return result
        },
        async loadRoutines(date) {
            const vm = this
            vm.loading = true
            await vm.fetchRoutinesStudent({studentId: vm.studentId, date: date})
            vm.loading = false
        }
    },
    watch: {
        async pickerDate(val) {
            let vm = this
            let date = vm.$moment(val).format('YYYY-MM-DD')
            vm.loadRoutines(date)
        },
    }
}
</script>

<style scoped>

.title-section {
    font-weight: 700;
    font-size: 20px;
    line-height: 22px;
}

.calendar-container {
    border: thin solid rgba(0, 0, 0, 0.12);
    border-radius: 8px;
    overflow: hidden;
}

::v-deep .v-date-picker-table {
    height: 100%;
}

::v-deep .v-date-picker-table .v-btn.v-btn--active:before {
    opacity: 0 !important;
}

::v-deep .v-date-picker-table .v-btn.v-btn--rounded {
    border-radius: 5px;
    padding-bottom: 8px;
}

::v-deep .v-date-picker-table__current {
    color: #333333 !important;
    box-shadow: 3px 3px 6px 0 rgba(1, 55, 46, 0.1) !important;
    border: thin solid rgba(0, 0, 0, 0.12) !important;
}

::v-deep .v-date-picker-table__current .v-btn__content {
    font-weight: 700 !important;
}

::v-deep .v-date-picker-table__events {
    height: 12px;
}

</style>